import React from "react";
import { Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

const Cta = () => {
    return (
        <React.Fragment>
            <section className="section bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <div className="section-title text-center">
                            <h3 className="title mb-4 pb-2">
                                Let’s Build Your Dream Team
                            </h3>
                            <p className="para-desc text-muted mx-auto">
                                Whether you&#39;re growing fast, replacing key leadership, or need help finding specialized talent,
                                Matrix Executive Search Group is your trusted recruitment partner. Let’s find the talent that
                                helps you lead, grow, and thrive.
                            </p>
                            <p className="text-muted">Ready to get started?</p>
                            <p className="text-muted">
                                Contact us today to speak with a dedicated recruiter and explore how we can help you build the
                                future of your workforce.
                            </p>
                            <div className="mt-4">
                                <Link to="/contact-us" className="btn btn-primary btn-hover mt-2">
                                    <i className="uil uil-rocket me-1"></i> Contact Us
                                </Link>
                                {/* <Link
                                    to="/contact-us"
                                    className="btn btn-outline-primary btn-hover ms-sm-1 mt-2"
                                >
                                    <i className="uil uil-capsule me-1"></i> Free Trial
                                </Link> */}
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Cta;
